import type { LoginClickType, LoginEventHandler } from '@/types';

export async function emitLoginClick(onEvent: LoginEventHandler | undefined, loginType: LoginClickType) {
  try {
    await onEvent?.({ type: 'login:click', loginType });
  } catch {
    // 登录点击埋点不阻断流程
  }
}
